module.exports = __webpack_public_path__ + "static/media/dps3.png.a527d14b.jpg";